import { useGlobalContext } from "../../../../../../Context/Context";
import { useEffect, useState } from "react";
import deleteImg from "../../../../../../picture/delete.png";
import ButtonsPocetna from "./ButtonsPocetna";
import ButtonsEdit from "./ButtonsEdit";
import Button from "../../../../../Custom/Button/Button";
import ButtonsAddItem from "./ButtonsAddItem";

const dataMock = {
  vrsta: "Viljuskar",
  tip: "B",
  regOznaka: "BG2356V",
  vozac: "Pera Peric",
  istice: "26.01.02",
  stavke: [
    { id: "1", sadrzaj: "Stavka 1", kom: 5, custom: false },
    { id: "2", sadrzaj: "Stavka 2", kom: 3, custom: false },
    { id: "3", sadrzaj: "Stavka 3", kom: 4, custom: false }
  ]
};

const styles = {
  button: {
    padding: "5px 30px",
    fontWeight: "bold"
  },
  cell: {
    padding: "5px",
    textAlign: "center"
  },
  cellHeader: {
    padding: "5px",
    textAlign: "center",
    backgroundColor: "#ccc"
  },
  smallCell: {
    width: "40px",
    textAlign: "center"
  }
};

function PreviewSredstvo({ id, cancelPreview }) {
  const [data, setData] = useState();
  const [newData, setNewData] = useState();
  // ""-pocetna, "EDIT", "ADD_ITEM"
  const [currentState, setCurrentState] = useState("");

  const { dictionary } = useGlobalContext();

  useEffect(() => {
    if (dataMock) {
      setData(dataMock);
      setNewData(dataMock);
    }
  }, [dataMock]);

  const handlePovecajKom = (id) => {
    setNewData((prev) => ({
      ...prev,
      stavke: prev.stavke.map((stav) =>
        stav.id === id ? { ...stav, kom: stav.kom + 1 } : stav
      )
    }));
  };

  const handleSmanjiKom = (id) => {
    setNewData((prev) => ({
      ...prev,
      stavke: prev.stavke.map((stav) =>
        stav.id === id && stav.kom > 0 ? { ...stav, kom: stav.kom - 1 } : stav
      )
    }));
  };

  const handleObrisiStavku = (id) => {
    setNewData((prev) => ({
      ...prev,
      stavke: prev.stavke.filter((stav) => stav.id !== id)
    }));
  };

  const handleAddStavka = () => {
    setCurrentState("ADD_ITEM");
  };

  if (!data || !newData) return;

  return (
    <div
      style={{
        padding: "25px",
        backgroundColor: "#f9f9f9",
        height: "100%",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <div style={{ flex: 1, overflowY: "auto" }}>
        <table style={{ width: "100%", marginBottom: "15px" }}>
          <tr>
            <th style={styles.cellHeader}>{dictionary["vrsta"]}</th>
            <th style={styles.cellHeader}>{dictionary["tip"]}</th>
            <th style={styles.cellHeader}>{dictionary["regOzn"]}</th>
            <th style={styles.cellHeader}>{dictionary["istice"]}</th>
            <th style={styles.cellHeader}>{dictionary["vozac"]}</th>
          </tr>
          <tr>
            <td style={styles.cell}>{newData.vrsta}</td>
            <td style={styles.cell}>{newData.tip}</td>
            <td style={styles.cell}>{newData.regOznaka}</td>
            <td style={styles.cell}>{newData.istice}</td>
            <td style={styles.cell}>{newData.vozac}</td>
          </tr>
        </table>
        <table style={{ width: "100%" }}>
          <tr>
            <th style={styles.cellHeader}>{dictionary["rb"]}</th>
            <th style={{ ...styles.cellHeader, width: "75%" }}>
              {dictionary["sadrzaj"]}
            </th>
            <th style={styles.cellHeader}>{dictionary["kom"]}</th>
          </tr>
          {(newData.stavke || []).map((stavka, index) => (
            <tr key={index}>
              <td style={styles.cell}>{index + 1}.</td>
              <td style={styles.cell}>{stavka.sadrzaj}</td>
              <td style={styles.cell}>
                {currentState !== "EDIT" ? (
                  stavka.kom
                ) : (
                  <div
                    style={{
                      display: "flex",
                      gap: "2px",
                      justifyContent: "space-between"
                    }}
                  >
                    {stavka.custom && stavka.kom === 0 ? (
                      <div onClick={() => handleObrisiStavku(stavka.id)}>
                        <Button activation={true}>
                          <img src={deleteImg} style={{ width: "25px" }} />
                        </Button>
                      </div>
                    ) : (
                      <div onClick={() => handleSmanjiKom(stavka.id)}>
                        <Button
                          activation={true}
                          style={{ padding: "0px 5px" }}
                        >
                          -
                        </Button>
                      </div>
                    )}
                    <div>{stavka.kom}</div>
                    <div onClick={() => handlePovecajKom(stavka.id)}>
                      <Button activation={true} style={{ padding: "0px 3px" }}>
                        +
                      </Button>
                    </div>
                  </div>
                )}
              </td>
            </tr>
          ))}
          {currentState === "EDIT" && (
            <tr>
              <td colSpan={2}></td>
              <td onClick={handleAddStavka}>
                <Button activation={true}>+</Button>
              </td>
            </tr>
          )}
        </table>
      </div>

      {currentState === "" && (
        <ButtonsPocetna
          cancelPreview={cancelPreview}
          setCurrentState={setCurrentState}
        />
      )}
      {currentState === "EDIT" && (
        <ButtonsEdit
          setCurrentState={setCurrentState}
          newData={newData}
          setNewData={setNewData}
          data={data}
          setData={setData}
        />
      )}
      {currentState === "ADD_ITEM" && (
        <ButtonsAddItem
          setCurrentState={setCurrentState}
          setNewData={setNewData}
        />
      )}
    </div>
  );
}

export default PreviewSredstvo;
